var React = require('react');

function IcTicket (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.041 3H7v10h1.996a.5.5 0 010 1H7v7h2.041a3 3 0 015.918 0H17v-7h-1.998a.5.5 0 110-1H17V3h-2.041A3 3 0 019.04 3zM11 13h2a.5.5 0 010 1h-2a.5.5 0 010-1z","fill":"currentColor"}));
}

IcTicket.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = IcTicket;

IcTicket.default = IcTicket;
